import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { chessPieces } from '../chessPieces-sidecar'
import { EChessMessage } from './chessMessageIds'

export interface IChessMessagePieceMove {
  pieceId: number
  i: number
  j: number
}

export const messageId = EChessMessage.PieceMove

export function write(m: IMessageWriter, d: IChessMessagePieceMove) {
  messageWriter.write8(m, messageId)
  messageWriter.write32(m, d.pieceId)
  messageWriter.write16(m, d.i)
  messageWriter.write16(m, d.j)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, messageId)

  let d: IChessMessagePieceMove = {
    pieceId: messageWriter.read32(m),
    i: messageWriter.read16(m),
    j: messageWriter.read16(m),
  }

  return d
}

export function test() {
  let ex: IChessMessagePieceMove = {
    pieceId: 100,
    i: 7,
    j: 8,
  }
  messageWriter.test('piece-move', ex, write, read)
}

export function process(m: IMessageWriter, isFromHost: boolean) {
  let msg = read(m)
  if (websockets.testRequiredFromHost(isFromHost, m, messageId)) {
    return
  }

  let cp = chessPieces.findByIdSafe(msg.pieceId)

  // console.log('move to', msg.i, msg.j, cp?.id, cp?.isDead)

  if (cp && !cp.isDead) {
    chessPieces.moveToIJ(cp, msg)
    // chessSounds.playPiecePutdown() // Already played by cursor?
  }
}

export function sendMessageAndImmediatelyExecute(msg: IChessMessagePieceMove) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
